<template>
	<div>
		<div style="display: inline-flex; align-items: center">
			<div>
				<h2>Use Workflow Template</h2>
			</div>
		</div>
		<p style="margin-top: 0px">
			Create a workflow from the template named <b>{{ workflowTemplate ? workflowTemplate.name : "" }}</b>
		</p>
		<templatePreview ref="templatePreview" :workflowObject="workflowTemplate" />
		<el-divider class="compressedDividerNoMarginTop"></el-divider>
		<el-form
			ref="form"
			class="createWorkflowFormWrapper"
			:rules="formRules"
			label-position="top"
			label-width="100px"
			:model="form"
		>
			<el-form-item prop="name" label="Your Workflow Name">
				<el-input
					@keyup.enter.native="createFromTemplate()"
					maxlength="50"
					placeholder="Template name"
					v-model="form.name"
				></el-input>
				<!-- Hidden input to stop page refresh on enter -->
				<el-input v-show="false" maxlength="50" placeholder="Workflow name" v-model="form.name"></el-input>
			</el-form-item>
			<el-form-item prop="description" label="Your Description">
				<el-input
					:autosize="{ minRows: 3, maxRows: 3 }"
					:show-word-limit="true"
					maxlength="150"
					resize="none"
					type="textarea"
					placeholder="..."
					v-model="form.description"
				></el-input>
			</el-form-item>
			<el-form-item>
				<el-button
					@click="createFromTemplate()"
					type="primary"
					:disabled="!form.name"
					style="width: 100%; margin-top: 12px"
					:loading="operationInProgress"
				>
					Use Template
				</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import templatePreview from "./templatePreview.vue";
export default {
	components: {
		templatePreview,
	},
	props: {
		workflowTemplate: Object,
	},
	data() {
		return {
			operationInProgress: false,
			formRules: {
				name: [{ required: true, message: "workflowToPublish", trigger: "change" }],
			},
			form: {
				name: "",
				description: "",
			},
		};
	},
	methods: {
		createFromTemplate() {
			let formIsValid;
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					formIsValid = valid;
				}
			});
			if (!formIsValid) {
				return;
			}
			this.operationInProgress = true;
			this.$confirm("Do you wish to create a workflow from this template. Continue?", "Warning", {
				confirmButtonText: "OK",
				cancelButtonText: "Cancel",
				type: "warning",
			})
				.then(async () => {
					this.form.description.trim();
					const result = await this.httpHelper("RUNTIME", "POST", "template/createWorkflowFromTemplate", {
						publishedWorkflowId: this.workflowTemplate.id,
						...this.form,
					});
					setTimeout(() => {
						this.operationInProgress = false;
						if (!result?.error) {
							this.$emit("operationComplete");
							this.$notify({
								title: "Success",
								message: "Workflow created from template",
								type: "success",
								position: "bottom-left",
							});
						} else {
							this.$notifyError(this, result.error);
						}
					}, 500);
				})
				.catch(() => {
					this.operationInProgress = false;
				});
		},
	},
};
</script>

<style scoped>
.createWorkflowFormWrapper {
	padding: 0px;
	padding-bottom: 20px;
	padding-top: 20px;
}

.compressedDividerNoMarginTop {
	margin-bottom: 0px !important;
}
</style>
